// extracted by mini-css-extract-plugin
module.exports = {"has-sidebar":"Page-module--has-sidebar--2HQqc","hasSidebar":"Page-module--has-sidebar--2HQqc","sidebar":"Page-module--sidebar--3m8RH","main":"Page-module--main--2WFup"};